const TYPES = {
    START_HOVER: 'START_HOVER',
    END_HOVER: 'END_HOVER'
};

export default {
    TYPES,

    startHover: () => ({
        type: TYPES.START_HOVER
    }),

    endHover: () => ({
        type: TYPES.END_HOVER
    })
};
